// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import { getRoleFromUserService, getUserRole } from '@mairistem/finances-utils';
import type { History } from 'history';
import React from 'react';
import { createPortal } from 'react-dom';
import { Route, Router } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import StorageKey from '../../../constants/common/storage';
import { setUserRoleCourant, useUserRoleCourant } from './userRoleStore';

interface ContextProps {
	children:
		| string
		| React.FunctionComponent<any>
		| React.ComponentClass<any, any>;
	history: History;
	path: string;
	scope: string;
}

const Context = ({ children, history, path, scope }: ContextProps) => {
	const userRole = useUserRoleCourant();

	const fetchUserRole = async () => {
		try {
			const userService = await getUserRole();
			const role = getRoleFromUserService(userService);
			setUserRoleCourant(role);
			// On dit que les migrations sont fini
			sessionStorage.setItem(StorageKey.MIGRATION, 'true');
		} catch {
			toast.error('Erreur lors de la recuperation du service utilisateur');
		}
	};

	// biome-ignore lint/correctness/useExhaustiveDependencies: Pas besoin de 'fetchUserRole'
	React.useEffect(() => {
		fetchUserRole();
	}, []);

	return (
		<>
			{scope === 'content' &&
				createPortal(<ToastContainer />, document.getElementById('root'))}

			<Router history={history}>
				<Route path={path}>
					{userRole &&
						(React.isValidElement(children)
							? children
							: React.createElement(children))}
				</Route>
			</Router>
		</>
	);
};

export default Context;
